// TODO: MOVE EACH SECTION TO COMPONENTS
// TODO: SEARCH API

import React, { useEffect, useState } from 'react'
import { Checklist } from '@cmd/library'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons'
import SwiperCore, { Navigation, Pagination } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Link } from 'react-router-dom'

import FloatingSearch from '../components/FloatingSearch'
import Select from '../components/form/Select'
import ProductItem from '../components/product/Item'
import TableCertified from '../components/TableCertified'

import { Cabang } from "./Cabang";

import { httpClient } from '../utils/httpClient';
import { rupiah, moneyToString } from '@cmd/library/lib/utils/function';

import 'swiper/swiper-bundle.css';

import './Home.css'

SwiperCore.use([Navigation, Pagination])

const Home = () => {
  const [selectedBranch, setSelectedBranch] = useState('Medan Putri Hijau')
  const [bikes, setBikes] = useState([]);
  const [cars, setCars] = useState([]);

  const fetchBikes = async () => {
    const res = await httpClient.get(`/inventory?isCar=Motor&isInternal=false&limit=5`)
    setBikes(res.data.rows)
  }

  const fetchCars = async () => {
    const res = await httpClient.get(`/inventory?isCar=Mobil&isInternal=false&limit=5`)
    setCars(res.data.rows)
  }

  useEffect(() => {
    fetchBikes();
  }, [])

  useEffect(() => {
    fetchCars();
  }, [])

  const setInstallmentString = (amount) => {
    const million = Math.floor(amount/100000)/10;
    if (million > 1) {
      return "Rp " + million + " " + "Jt"
    } else {
      return "Rp " + amount/1000 + " " + "Rb"
    }
  }

  const renderSlides = (datum = [], isCar) => {
    if (datum.length > 0) {
      return (
        <Swiper
          spaceBetween={32}
          navigation
          slidesPerView={2.5}
          breakpoints={{
            320: {
              slidesPerView: 1.5
            },
            480: {
              slidesPerView: 1.5
            },
            768: {
              slidesPerView: 2.5
            }
          }} >
            {
              datum.map((d) => (
                <SwiperSlide key={d.id}>
                  <Link to={`/${isCar ? "mobil" : "motor"}/${d.id}`}>
                    <ProductItem
                      name={`${d.year} ${isCar ? d.CarType.brand_name : d.BikeType.brand_name}`}
                      image={d.images[0]}
                      detail={{
                        id: d.id,
                        isCar: isCar,
                        year: d.year,
                        type: `${isCar ? `${d.CarType.specification} ${d.CarType.type} ${d.CarType.transmission == 'Manual' ? "MT" : "AT"} ${d.class ? d.class : ""}` : `${d.BikeType.type}`}`,
                        location: d.City.name,
                        price: d.price,
                        condition: d.condition,
                        mileage: `${d.mileage} km`,
                        installment: `${setInstallmentString(d.installment)}/bln`,
                        belowMarketPrice: d.belowMarkret
                      }}
                    />
                  </Link>
                </SwiperSlide>
              ))
            }
        </Swiper>
      )
    }

    return null
  }

  return (
    <div className="home">
      <section className="section-banner-hero hero">
        <Swiper
          navigation
          pagination={{ clickable: true }}
          slidesPerView={1} >
          <SwiperSlide>
            <div className="hero-wrapper">
              <div className="container">
                <div className="row align-items-center">
                  <div className="col-md-6">
                    <div>
                      <h1 className="hero-text-big">Miliki Mobil Bekas Berkualitas.</h1>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div>
                      <img src={"https://drive.google.com/uc?id=1CvytDM56MbCev7LrQEQ0KbFX5bxFBidN"} alt=""/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="hero-wrapper">
              <div className="container">
                <div className="row align-items-center">
                  <div className="col-md-6">
                    <div>
                      <h1 className="hero-text-big">Buruan Motor Yang Kamu Cari Ada Disini.</h1>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div>
                      <img src={"https://drive.google.com/uc?id=1XFL-bdYrSr0AkLq-zHMIOBmpexGuUqsB"} alt=""/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="hero-wrapper">
              <div className="container">
                <div className="row align-items-center">
                  <div className="col-md-6">
                    <div>
                      <h1 className="hero-text-big">Miliki Kendaraan</h1>
                      <h1 className="hero-text-big">Masa Depan.</h1>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div>
                      <img src={"https://drive.google.com/uc?id=1b7dVTvGjRaard7-9T1GUDXL0sU_jffDv"} alt=""/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
        <FloatingSearch />
      </section>
      <div className="section-wrapper">
        <div className="container">
          <div className="row">
            <div className="col-md-3">
              <div>
                <h1 className="title-big">Mobil Terpopuler</h1>
                <div className="best-section-art-wrapper">
                  <img src={require('../assets/img/car-art.png')} alt=""/>
                </div>
              </div>
            </div>
            <div className="col-md-9">
              { renderSlides(cars, true) }
            </div>
          </div>
        </div>
      </div>
      <div className="section-wrapper section-gray">
        <div className="container">
          <div className="row">
            <div className="col-md-3">
              <div>
                <h1 className="title-big">Motor Terpopuler</h1>
                <div className="best-section-art-wrapper">
                  <img src={require('../assets/img/bike-art.png')} alt=""/>
                </div>
              </div>
            </div>
            <div className="col-md-9">
              { renderSlides(bikes, false) }
            </div>
          </div>
        </div>
      </div>
      <section className="section-why section-wrapper">
        <div className="container">
          <div className="row mb--2">
            <div className="col">
              <h1 className="title-big">Sebutkan Kelebihan Kamu.</h1>
            </div>
          </div>
          <div className="row">
            <div className="col-md-3">
              <div className="section-why-content">
                <div className="mb--1 fx">
                  <span className="mr--1">
                    <Checklist />
                  </span>
                  <p className="text--weight-500">Unit Siap Pakai</p>
                </div>
                <div>
                  <p>
                    Unit telah dicek dan 100% siap pakai
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="section-why-content">
                <div className="mb--1 fx">
                  <span className="mr--1">
                    <Checklist />
                  </span>
                  <p className="text--weight-500">Surat Kendaraan Lengkap</p>
                </div>
                <div>
                  <p>
                    STNK, BPKB, maupun faktur pajak lengkap dan terjamin legalitasnya
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="section-why-content">
                <div className="mb--1 fx">
                  <span className="mr--1">
                    <Checklist />
                  </span>
                  <p className="text--weight-500">Certified Pre Owned</p>
                </div>
                <div>
                  <p>
                   Unit bersertifikat mendapatkan garansi hingga 100 hari
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="section-why-content">
                <div className="mb--1 fx">
                  <span className="mr--1">
                    <Checklist />
                  </span>
                  <p className="text--weight-500">Pembiayaan Langsung</p>
                </div>
                <div>
                  <p>
                    Pembiayaan dari kami dengan DP terjangkau, bunga bersaing, proses mudah & cepat
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section-wrapper section-gray section-intercect-bg">
        <div className="container">
          <div className="row justify-content-center mb--2">
            <div className="col-md-8">
              <h1 className="title-big text--center">Capella Certified</h1>
              <p className="text--center">
                Mobil Capella Certified adalah mobil bekas bersertifikat yang sangat berbeda dari mobil bekas pada umumnya. Ada beberapa alasan mengapa Mobil Capella Certified lebih baik dan layak untuk dibeli.
              </p>
            </div>
          </div>
          <div className="row justify-content-center mb--2">
            <div className="col-md-8">
              <div className="embed-responsive embed-responsive-16by9">
                <iframe className="embed-responsive-item" src="https://www.youtube.com/embed/093fsgE_YSM"></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section-wrapper">
        <div className="container">
          <div className="row">
            <div className="col">
              <TableCertified />
            </div>
          </div>
        </div>
      </section>
      <div className="section-wrapper section-map">
        <div className="container-overflow-half">
          <div className="container-overflow-half--item order-2 order-sm-2 order-md-1">
            <div className="embed-responsive embed-responsive-16by9">
              <iframe className="embed-responsive-item" title="capella office" src={Cabang[`${selectedBranch}`].gmap} aria-hidden="false" tabIndex="0"></iframe>
            </div>
          </div>
          <div className="container-overflow-half--item order-1 order-sm-1 order-md-2">
            <div className="section-map-wrapper-content">
              <div className="mb--2">
                <h1 className="title-big">Kunjungi Showroom</h1>
              </div>
              <div className="mb--1">
                <div className="select-office-wrapper">
                  <Select
                    onChange={(value) => setSelectedBranch(value)}
                    value={selectedBranch}
                    id="branch"
                    options={Object.values(Cabang)}
                  />
                </div>
              </div>
              <div className="section-map-detail">
                <ul>
                  <li>{Cabang[`${selectedBranch}`].address}</li>
                  <li>{Cabang[`${selectedBranch}`].phone_number}</li>
                  <li>
                    {Cabang[`${selectedBranch}`].open[0]}<br/>
                    {Cabang[`${selectedBranch}`].open[1]}
                  </li>
                </ul>
              </div>
              <div className="section-map-contact">
                <div className="section-map-contact--wrapper">
                  <p className="mb--0">
                    {/* <a href={Cabang[`${selectedBranch}`].whatsapplink} className="whatsapp" target="_blank"> */}
                    <a href="https://api.whatsapp.com/send?phone=6283181543776&text=Halo,%20Saya%20mau%20bertanya%20tentang " className="whatsapp" target="_blank">
                      <span className="mr--1">
                        <FontAwesomeIcon icon={faWhatsapp} />
                      </span>
                      {/* {Cabang[`${selectedBranch}`].pic} */}
                      Customer Care
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Home
